import { render } from "./TableMenu.vue?vue&type=template&id=2fd9f52e&scoped=true"
import script from "./TableMenu.vue?vue&type=script&lang=js"
export * from "./TableMenu.vue?vue&type=script&lang=js"

import "./TableMenu.vue?vue&type=style&index=0&id=2fd9f52e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd9f52e"]])

export default __exports__